import { useForm, useFormContext } from 'react-hook-form';

import { PlotOverviewMediaFileType } from '@/api/rest/resources/types/plot';

export enum PlotOverviewMediaFileFormFields {
  name = 'title',
  caption = 'description',
  type = 'type',
  file = 'file',
  thumbnail = 'thumbnail',
}

export type ControlsFormFieldValues = {
  [PlotOverviewMediaFileFormFields.name]: string;
  [PlotOverviewMediaFileFormFields.caption]: string;
  [PlotOverviewMediaFileFormFields.type]: PlotOverviewMediaFileType;
  [PlotOverviewMediaFileFormFields.file]?: File;
  [PlotOverviewMediaFileFormFields.thumbnail]?: File;
};

export const usePlotOverviewMediaFileForm = useForm<ControlsFormFieldValues>;

export const usePlotOverviewMediaFileFormContext = useFormContext<ControlsFormFieldValues>;
